export const titleLogin = 'Iniciar sesión | Angellira';
export const titleAccess = 'Conceder | Angellira';
export const titleRecover = 'Recuperar | Angellira';
export const titleInpersonate = 'Personificar | Angellira';
export const titlePin = 'Validar Pin | Angellira';

export const pinMessage = 'Introduzca el Pin para acceder al sistema';
export const validatePin = 'Validar';

export const credentials = 'Introduzca sus credenciales para acceder al sistema';
export const clientAccess = 'solicitando acceso a su cuenta:';
export const passInsert = 'Introduzca su nueva contraseña';
export const userInpersonate = 'Introduzca el usuario a personificar';

export const user = 'Usuario';
export const pass = 'Contraseña';
export const passConfirmation = 'Confirmación de Contraseña';

export const passMust = 'Tu contraseña debe tener al menos:';
export const passLength = 'al menos 9 y como máximo 15 caracteres';
export const passLCLetters = '1 letra mayúscula';
export const passUCLetters = '1 letra minúscula';
export const passNumbers = '2 números';
export const passSpecial = '1 personaje especial';
export const passConfirmationHelper = `Debe ser el mismo que en el campo "${pass}"`;
// eslint-disable-next-line max-len
export const ensurePass = 'Su contraseña no pudo ser cambiada. No satisface el patrón de complejidad o lo ha usado recientemente. Elige otro.';

export const login = 'Iniciar sesión';
export const recover = 'Recuperar';
export const allow = 'Permitir';
export const inpersonate = 'Personificar';

export const forgotten = 'Olvidé mi contraseña';
export const logout = 'Cerrar sesión';

export const copyright = 'Todos los derechos reservados';

export const ecosystem = 'Ecosistema Angel Lira';
export const tagline = 'Su operación, en un solo lugar.';
export const connected = '12 soluciones conectadas';
export const network = 'Una red. Una operación.';
export const noCompany = '¿Su empresa aún no está registrada?';
export const noCompanyHelp = 'Solicite el registro al administrador de la plataforma.';

export const aliaNoAccess = 'Aún no tiene acceso a <span class="alia-dialog__name">ALIA</span>';
export const aliaDescription = 'La primera inteligencia artificial creada para trabajar en la operación logística.';
export const aliaKnow = 'Conocer ALIA';

export const successes = {
  'valid-pin': 'Ya tienes un pin valido, revisa tu email',

  'email-pin': 'Revise su correo electrónico para canjear el pin',
  'email-sent': 'Revise su correo electrónico para recuperar su contraseña',
  // eslint-disable-next-line max-len
  'pass-recovered': '¡Contraseña alterada con éxito! Usted ya puede iniciar sesión en los sistemas Angellira utilizando la nueva contraseña!',
  'lease-sent': 'Revise su correo electrónico para autorizar la sesión.',
  'session-allowed': 'Sesión autorizada',
};

export const errors = {
  'missing-user': 'Por favor, ingrese Usuario para la recuperación',
  'missing-email': 'No tienes un correo electrónico registrado.',
  'missing-mimic': 'No se puede personificar el usuario',

  'invalid-pin': 'Pin inválido, intente de nuevo',
  'expired-pin': 'Este pin ya ha caducado, inténtalo de nuevo.',

  'invalid-user': 'Usuario invalido',
  'invalid-password': 'Contraseña invalido',
  'invalid-recover': 'Sesión inválida, solicite una nueva recuperación',
  'invalid-permission': 'Permiso inválido',
  'invalid-client': 'Servicio no encontrado',
  'invalid-token': 'Token inválido',
  // eslint-disable-next-line max-len
  'invalid-company': 'No se pudo llegar a lirasys. Por favor, póngase en contacto con <a href="mailto:help@angellira.com.br">help@angellira.com.br</a>',
  'max-attempts': 'Se ha superado el número de intentos, inténtalo de nuevo en unos minutos',
  'out-until': 'Puede volver a intentar el',
  // eslint-disable-next-line max-len
  'multiple-sessions': 'Este usuario ya está autenticado en otra sesión. <a href="/session/lease">Siga este enlace</a> para permitir otra sesión por correo electrónico.',
  'no-lease': 'No es posible autorizar otra sesión.',
  'failed': 'Falló al intentar procesar su solicitud. Intenta nuevamente más tarde.',

  'ip-not-allowed': 'Su dispositivo no está autorizado para acceder a esta empresa.',

  'jwt-must-be-provided': 'Sesión inválida, solicite una nueva recuperación',
  'jwt-expired': 'Su sesión ha expirado',
  'recover-expired': 'Este enlace recuperación ha expirado, solicitar de nuevo',

  // eslint-disable-next-line max-len
  'pw-validation-error': 'Su contraseña no pudo ser cambiada. No satisface el patrón de complejidad o lo ha usado recientemente. Elige otro.',
  'pw-unconfirmed': 'Las contraseñas insertadas no confieren',
  // eslint-disable-next-line max-len
  'pw-expired': 'Su contraseña ha caducado. Realice el proceso de recuperación para generar una nueva contraseña válida',
};
